(function($) {
	const initMaps = function() {
		$('.gmap').each(function() {
			const args = {
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				styles: [
					{
						featureType: 'all',
						elementType: 'labels.text.fill',
						stylers: [
							{
								saturation: '0',
							},
							{
								lightness: '0',
							},
							{
								gamma: '0',
							},
							{
								weight: '0.01',
							},
							{
								color: '#94002b',
							},
						],
					},
					{
						featureType: 'all',
						elementType: 'labels.text.stroke',
						stylers: [
							{
								visibility: 'on',
							},
							{
								color: '#ffffff',
							},
							{
								lightness: 16,
							},
						],
					},
					{
						featureType: 'all',
						elementType: 'labels.icon',
						stylers: [
							{
								visibility: 'off',
							},
						],
					},
					{
						featureType: 'administrative',
						elementType: 'geometry.fill',
						stylers: [
							{
								lightness: 20,
							},
						],
					},
					{
						featureType: 'administrative',
						elementType: 'geometry.stroke',
						stylers: [
							{
								color: '#fefefe',
							},
							{
								lightness: 17,
							},
							{
								weight: 1.2,
							},
						],
					},
					{
						featureType: 'administrative.neighborhood',
						elementType: 'labels',
						stylers: [
							{
								visibility: 'off',
							},
						],
					},
					{
						featureType: 'landscape',
						elementType: 'geometry',
						stylers: [
							{
								color: '#ebebeb',
							},
							{
								lightness: 20,
							},
						],
					},
					{
						featureType: 'poi',
						elementType: 'geometry',
						stylers: [
							{
								color: '#f5f5f5',
							},
							{
								lightness: 21,
							},
						],
					},
					{
						featureType: 'poi.park',
						elementType: 'geometry',
						stylers: [
							{
								color: '#dedede',
							},
							{
								lightness: 21,
							},
						],
					},
					{
						featureType: 'road.highway',
						elementType: 'geometry.fill',
						stylers: [
							{
								lightness: 17,
							},
							{
								color: '#ffffff',
							},
						],
					},
					{
						featureType: 'road.highway',
						elementType: 'geometry.stroke',
						stylers: [
							{
								color: '#ffffff',
							},
							{
								lightness: 29,
							},
							{
								weight: 0.2,
							},
						],
					},
					{
						featureType: 'road.arterial',
						elementType: 'geometry',
						stylers: [
							{
								color: '#ffffff',
							},
							{
								lightness: 18,
							},
						],
					},
					{
						featureType: 'road.local',
						elementType: 'geometry',
						stylers: [
							{
								color: '#ffffff',
							},
							{
								lightness: 16,
							},
						],
					},
					{
						featureType: 'transit',
						elementType: 'geometry',
						stylers: [
							{
								color: '#f2f2f2',
							},
							{
								lightness: 19,
							},
						],
					},
					{
						featureType: 'water',
						elementType: 'geometry',
						stylers: [
							{
								color: '#9b9b9b',
							},
							{
								lightness: 17,
							},
						],
					},
				],
			};

			const lat = parseFloat($(this).attr('data-lat'));
			const lng = parseFloat($(this).attr('data-lng'));
			args.center = new google.maps.LatLng(lat, lng);

			const map = new google.maps.Map(this, args);

			map.setOptions({
				zoomControl: false,
				scrollwheel: false,
				disableDoubleClickZoom: true,
			});
			map.setZoom(14);

			const marker = new google.maps.Marker({
				position: new google.maps.LatLng(lat, lng),
				map,
				icon: {
					url: `${ wkScriptVars.themeUrl }/assets/dist/images/pin.svg`,
					scaledSize: new google.maps.Size(24, 24),
					anchor: new google.maps.Point(12, 24),
				},
			});

			marker.setMap(map);
		});
	};

	if (typeof google !== 'undefined') {
		google.maps.event.addDomListener(window, 'load', initMaps);
	}
}(window.jQuery));

